import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {ModalModule} from 'ngx-bootstrap/modal';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {MainComponent} from './main/main.component';
import {AuthComponent} from './auth/auth.component';
import {RouterModule} from '@angular/router';
import {SidebarComponent} from './sidebar/sidebar.component';
import {LogoComponent} from './logo/logo.component';
import {PageHeaderComponent} from './page-header/page-header.component';
import {PageBreadcrumbComponent} from './page-breadcrumb/page-breadcrumb.component';
import {PageHeadingComponent} from './page-heading/page-heading.component';
import {PageFooterComponent} from './page-footer/page-footer.component';
import {UiModule} from '../ui/ui.module';
import {NavigationModule} from '../navigation/navigation.module';
import {ShortcutModalComponent} from './shortcut-modal/shortcut-modal.component';
import {FabShortcutComponent} from './fab-shortcut/fab-shortcut.component';
import {DropdownUserComponent} from './dropdown-user/dropdown-user.component';
import {NotificationComponent} from './notification/notification-component/notification.component';
import {NotificationModalComponent} from './notification/notification-modal/notification-modal.component';
import {SettingsModalComponent} from './settings/settings-modal/settings-modal.component';
import {GeneralSettingComponent} from './settings/settings-components/general-setting-component/general-setting.component';
import {MainSettingComponentComponent} from './settings/settings-components/main-setting-component/main-setting-component.component';
import {ModalViewComponent} from './settings/settings-components/modal-view/modal-view.component';
import {DashboardSettingComponent} from './settings/settings-components/dashboard-setting/dashboard-setting.component';
import {ViewSettingsComponent} from './settings/settings-components/view-settings/view-settings.component';
import {FormSettingComponent} from './settings/settings-components/form-setting/form-setting.component';
import {FormsModule} from '@angular/forms';

@NgModule({
    declarations: [MainComponent, AuthComponent, SidebarComponent,
        LogoComponent,
        PageHeaderComponent, PageBreadcrumbComponent, PageHeadingComponent,
        PageFooterComponent,
        SettingsModalComponent,
        NotificationModalComponent,
        ShortcutModalComponent,
        FabShortcutComponent,
        DropdownUserComponent,
        NotificationComponent,
        MainSettingComponentComponent,
        GeneralSettingComponent,
        ModalViewComponent,
        FormSettingComponent,
        DashboardSettingComponent,
        ViewSettingsComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        BsDropdownModule,
        ModalModule,
        ButtonsModule,

        NavigationModule,
        UiModule,
        FormsModule

    ],
    exports: [MainComponent, AuthComponent, SidebarComponent],
    entryComponents: [ShortcutModalComponent]
})
export class LayoutModule {
}
